import React from 'react';
import { UBManageElementType } from '../types/ub-manage-element-mode';
import { UFB_BROWSE_TYPE } from '../ufb-browse-types';
import { createUFBContext as createUFBMobileContext } from '../ufb-mobile/create-ufb-context';
import { BrowseButtons } from './browse/browse-buttons.react-component';
import { BrowseNavCustomCategories } from './browse/browse-nav-custom-categories.react-component';
import { BrowseNavLearningPathFolders } from './browse/browse-nav-learning-path-folders.react-component';
import { BrowseNavLevelOneItems } from './browse/browse-nav-level-one-items.react-component';
import { ManageButton } from './manage/manage-button.react-component';
import { ManageDropdown } from './manage/manage-dropdown.react-component';
import { PackageAlert } from './manage/package-alert.react-component';
export function createUFBContext(udData, i18n, ubManageElementMode = UBManageElementType.Button) {
  var _udData$Config$featur;
  const mobileContext = createUFBMobileContext(udData, i18n);
  const isLearningPathEnabled = (_udData$Config$featur = udData.Config.features) === null || _udData$Config$featur === void 0 || (_udData$Config$featur = _udData$Config$featur.organization) === null || _udData$Config$featur === void 0 || (_udData$Config$featur = _udData$Config$featur.learning_path) === null || _udData$Config$featur === void 0 ? void 0 : _udData$Config$featur.enabled;
  return {
    mobileContext,
    urls: mobileContext.urls,
    badgeContext: mobileContext.badgeContext,
    logo: mobileContext.logo,
    browseNavDropdownText: isLearningPathEnabled ? i18n.gettext('Explore') : undefined,
    get browseButtons() {
      return /*#__PURE__*/React.createElement(BrowseButtons, null);
    },
    instructorDropdownText: isLearningPathEnabled ? i18n.gettext('Teach') : i18n.gettext('Instructor'),
    prospectiveInstructorDropdownText: isLearningPathEnabled ? i18n.gettext('Teach') : i18n.gettext('Create a course'),
    prospectiveInstructorHeadline: i18n.gettext('Create or add custom courses to share within your organization.'),
    prospectiveInstructorCTAText: i18n.gettext('Try it now'),
    get packageAlert() {
      return /*#__PURE__*/React.createElement(PackageAlert, null);
    },
    get manageElement() {
      return ubManageElementMode === UBManageElementType.Dropdown ? /*#__PURE__*/React.createElement(ManageDropdown, null) : /*#__PURE__*/React.createElement(ManageButton, null);
    },
    getBrowseNavLevelOneItems(itemFinders) {
      return /*#__PURE__*/React.createElement(BrowseNavLevelOneItems, {
        itemFinders: itemFinders
      });
    },
    getBrowseNavLevelTwoItems(selectedLevelOneItem) {
      if (selectedLevelOneItem.type === UFB_BROWSE_TYPE.LEARNING_PATHS) {
        return /*#__PURE__*/React.createElement(BrowseNavLearningPathFolders, null);
      }
      if (selectedLevelOneItem.type === UFB_BROWSE_TYPE.CUSTOM_CATEGORIES) {
        return /*#__PURE__*/React.createElement(BrowseNavCustomCategories, null);
      }
      return null;
    }
  };
}
//# sourceMappingURL=create-ufb-context.js.map